import { WORLD_SIZE } from "../constants.js";
import { FEATURE_TYPES, defaultParams } from "../features/index.js";

const STORAGE_KEY = "mars-digger-layout-v1";

export function cloneLayout(layout) {
    return JSON.parse(JSON.stringify(layout));
}

export function normalizeLayout(raw, fallback) {
    if (!raw || raw.version !== 1 || !Array.isArray(raw.features)) {
        return cloneLayout(fallback);
    }

    return {
        version: 1,
        size: WORLD_SIZE,
        seed: raw.seed | 0,
        base: {
            ...fallback.base,
            ...raw.base,
            height: numberOr(raw.base?.height, fallback.base.height),
            amplitude: numberOr(raw.base?.amplitude, fallback.base.amplitude),
            scale: numberOr(raw.base?.scale, fallback.base.scale),
            octaves: raw.base?.octaves | 0 || fallback.base.octaves,
        },
        spawn: {
            x: numberOr(raw.spawn?.x, WORLD_SIZE / 2),
            z: numberOr(raw.spawn?.z, WORLD_SIZE / 2),
        },
        features: raw.features.map((feature, index) => {
            const type = FEATURE_TYPES.includes(feature.type) ? feature.type : "plains";
            return {
                id: feature.id || `f${index}`,
                type,
                x: numberOr(feature.x, WORLD_SIZE / 2),
                z: numberOr(feature.z, WORLD_SIZE / 2),
                sx: Math.max(8, numberOr(feature.sx, 80)),
                sz: Math.max(8, numberOr(feature.sz, 60)),
                rotation: numberOr(feature.rotation, 0),
                height: numberOr(feature.height, 20),
                strength: numberOr(feature.strength, 1),
                seed: feature.seed | 0,
                params: { ...defaultParams(type), ...feature.params },
            };
        }),
    };
}

export function loadLayout(shipped, debug) {
    if (debug) {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved) return normalizeLayout(JSON.parse(saved), shipped);
        } catch (error) {
            console.warn("Ignoring saved terrain layout", error);
        }
    }
    return cloneLayout(shipped);
}

export function saveLayout(layout) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(layout));
}

export function clearSavedLayout() {
    localStorage.removeItem(STORAGE_KEY);
}

export function downloadLayout(layout) {
    const blob = new Blob([JSON.stringify(layout, null, 4)], {
        type: "application/json",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "layout.json";
    link.click();
    URL.revokeObjectURL(link.href);
}

function numberOr(value, fallback) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
}
